import { render, staticRenderFns } from "./ChangeLoading.vue?vue&type=template&id=504eb9ff&scoped=true&"
import script from "./ChangeLoading.vue?vue&type=script&lang=js&"
export * from "./ChangeLoading.vue?vue&type=script&lang=js&"
import style0 from "./ChangeLoading.vue?vue&type=style&index=0&id=504eb9ff&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504eb9ff",
  null
  
)

export default component.exports